import { config } from '@/../app.config'
import Axios from 'axios'
import store from '@/store'
import Auth, { CognitoUser } from '@aws-amplify/auth'
import { Storage } from '@/types/amplify'
import _ from 'lodash';

export default {
  SET_BALANCE: ({ commit }: any, balance: number): void => {
    commit('SET_BALANCE', balance)
  },
  GET_BALANCE: async ({ commit }: any): Promise<void> => {
    return await Auth.currentAuthenticatedUser().then( (res: CognitoUser) => {
        return Storage.get(config.userCacheEndpoint, {
          level: 'private',
          expires: 10,
          download: true,
        })
        .then(result => {
          if (_.isObject(result) && _.has(result, 'Body')) {
            // @ts-ignore
            const res: IPlayerCache = JSON.parse(result.Body.toString())
            commit('SET_BALANCE', res.balance)
          }
        })
        .catch(err => {
          console.log(err)
        })
      })
  },
  SET_VERIFYNAME: ({ commit }: any, name: string): void => {
    commit('SET_VERIFYNAME', name)
    //@ts-ignore
    $cookies.set('qpverifyname', name)
  },
  SET_USERNAME: ({ commit }: any, name: string): void => {
    commit('SET_USERNAME', name)
  },
  SET_CLASSIC: ({ commit, getters }: any, classic: boolean): void => {
    commit('SET_CLASSIC', classic) 
  },
  CLEAR_PLAYER: ({ commit, dispatch }: any): void => {
    commit('CLEAR_PLAYER')
    dispatch('CLEAR_DRAFTS')
    dispatch('CLEAR_GAME')
  }
};
